module.exports = __webpack_public_path__ + "static/media/breakApart-dark.514eb640.svg";